var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.12616V3.31039C11 3.39092 10.9707 3.46671 10.9227 3.51408L6.33359 7.99995L10.9227 12.4858C10.9707 12.5332 11 12.609 11 12.6895V13.8737C11 13.9764 10.9133 14.0364 10.8512 13.9764L5.15469 8.4089C4.94844 8.20679 4.94844 7.7931 5.15469 7.59257L10.8512 2.02511C10.9133 1.96353 11 2.02353 11 2.12616Z",
    fill: "#1890FF",
    stroke: "#1890FF",
    strokeWidth: 0.333333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.e82eecd82a6a08230af03364ec4e9ba1.svg";
export { ForwardRef as ReactComponent };